<div *ngIf="authFlag">
  <app-landing-page></app-landing-page>
</div>
<div class="global"></div>
<router-outlet></router-outlet>